import React from 'react';

export const SettingsSystemLogs: React.FC = () => {
  return (
    <div>
      <h4>System Logs</h4>
    </div>
  );
};
